import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "empty-placeholder"
}
const _hoisted_2 = {
  key: 2,
  class: "beru-detail",
  "data-qa": "beru-detail-block"
}
const _hoisted_3 = { class: "beru-detail-badges" }
const _hoisted_4 = {
  key: 0,
  class: "success",
  "data-qa": "beru-detail-badge-shift-cost"
}
const _hoisted_5 = {
  key: 1,
  class: "success",
  "data-qa": "beru-detail-badge-shift-cost-rd"
}
const _hoisted_6 = {
  key: 0,
  class: "beru-detail-status",
  "data-qa": "beru-detail-status-canceled"
}
const _hoisted_7 = { class: "beru-detail-row" }
const _hoisted_8 = {
  key: 0,
  "data-qa": "beru-detail-title-pharm"
}
const _hoisted_9 = {
  key: 1,
  class: "beru-detail-interval",
  "data-qa": "beru-detail-value-interval"
}
const _hoisted_10 = { class: "beru-detail-timings" }
const _hoisted_11 = {
  key: 0,
  "data-qa": "beru-detail-timing-shift"
}
const _hoisted_12 = {
  key: 1,
  "data-qa": "beru-detail-timing-dinner"
}
const _hoisted_13 = {
  class: "beru-detail-chars",
  "data-qa": "beru-detail-chars-block"
}
const _hoisted_14 = { "data-qa": "beru-detail-value-date" }
const _hoisted_15 = { "data-qa": "beru-detail-label-pharm-address" }
const _hoisted_16 = {
  class: "several-lines",
  "data-qa": "beru-detail-value-pharm-address"
}
const _hoisted_17 = {
  key: 0,
  "data-qa": "beru-detail-value-pharm-city"
}
const _hoisted_18 = {
  key: 1,
  "data-qa": "beru-detail-value-pharm-street"
}
const _hoisted_19 = { "data-qa": "beru-detail-value-reason" }
const _hoisted_20 = { "data-qa": "beru-detail-value-reason-type" }
const _hoisted_21 = {
  class: "several-lines",
  "data-qa": "beru-detail-value-anchor"
}
const _hoisted_22 = {
  key: 0,
  "data-qa": "beru-detail-value-anchor-name"
}
const _hoisted_23 = {
  key: 1,
  "data-qa": "beru-detail-value-anchor-address"
}
const _hoisted_24 = {
  key: 1,
  class: "beru-detail-cancel"
}
const _hoisted_25 = {
  key: 0,
  class: "beru-detail-confirm",
  "data-qa": "beru-detail-confirm-cancel-block"
}

import VitaEmptyPlaceholder from "@/components/UI/VitaEmptyPlaceholder.vue";
import { computed, Ref, ref } from "vue";
import {
  PerfectScrollbar,
  PerfectScrollbarExpose,
} from "vue3-perfect-scrollbar";
import VitaButton from "./UI/VitaButton.vue";
import VitaInfoModal from "./UI/VitaInfoModal.vue";
import VitaBeruTimeline from "./VitaBeruTimeline.vue";
import { BeruCardFree, BeruCardTaken, BeruDetails } from "@/types/beru";
import VitaLoaderSpinner from "./UI/VitaLoaderSpinner.vue";
import store from "@/store/index";
import { AxiosError } from "axios";
import { ErrorResponseData } from "@/types";
import { addHours, differenceInMinutes, format } from "date-fns";
import ru from "date-fns/locale/ru";
import { useToast, POSITION } from "vue-toastification";

interface Props {
  open: boolean;
  card: BeruCardFree | BeruCardTaken | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VitaBeruDetailModal',
  props: {
    open: { type: Boolean },
    card: {}
  },
  emits: ['toggleInfoModal', 'canceled'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const toast = useToast();
const isDetailLoading = ref(false);
const detailError = ref('');
const timelineScroll: Ref<PerfectScrollbarExpose | null> = ref(null);
const showCancellationConfirm = ref(false);
const cancelInProgress = ref(false);

const scrollOptions = {
  minScrollbarLength: 60,
  wheelPropagation: false,
  suppressScrollX: true,
};

const beruDetail = computed<BeruDetails | null>(
  () => store.getters["beru/beruDetail"],
);

const onBeruModalOpen = async () => {
  if (!props.card) return;

  try {
    detailError.value = "";
    isDetailLoading.value = true;
    showCancellationConfirm.value = false
    store.commit("beru/setBeruDetail", null);
    await store.dispatch("beru/getBeruDetail", props.card.id);
  } catch (e) {
    const err = e as AxiosError<ErrorResponseData>;
    detailError.value = err.status !== 500 && err.response?.data ? err.response.data.message : "Ошибка загрузки данных";
  } finally {
    isDetailLoading.value = false;
  }
};

const pharmTz = computed<number>(() => store.getters["data/pharmTz"] || 0);

// Получаем дату и время с учётом смещения таймзоны аптеки
const toPharmDate = (iso: string): Date => {
  const timeZone = pharmTz.value + new Date().getTimezoneOffset() / 60;
  return addHours(new Date(iso), timeZone);
};

const formatDate = (iso: string): string =>
  format(toPharmDate(iso), "d MMMM yyyy", { locale: ru });

const formatTime = (iso: string): string => format(toPharmDate(iso), "HH:mm");

const shiftDurationHours = computed<number>(() => {
  if (!beruDetail.value) return 0;
  return (
    differenceInMinutes(
      new Date(beruDetail.value.dateTo),
      new Date(beruDetail.value.dateFrom),
    ) / 60
  );
});

const dinnerDuration = computed<number>(() => {
  const hours = shiftDurationHours.value;
  let dinner = 0;
  if (hours >= 13) dinner = 1.5;
  else if (hours >= 9) dinner = 1;
  else if (hours >= 5) dinner = 0.5;
  return dinner;
});

// Длительность смены с учётом обеда
const shiftDuration = computed<number>(() => {
  if (!beruDetail.value) return 0;
  return shiftDurationHours.value - dinnerDuration.value;
});

// Cвободная ли потребность
const isShiftFree = computed<boolean>(
  () =>
    beruDetail.value?.toCancel === false &&
    beruDetail.value.armZortCanceledAt === null,
);

const onTimelineToggle = () => {
  requestAnimationFrame(() => {
    timelineScroll.value?.ps?.update();

    const el = timelineScroll.value?.ps?.element as HTMLElement;
    if (el) el.scrollTop = 0;
  });
};

const cancelBeruShift = async (id: string) => {
  try {
    cancelInProgress.value = true;
    await store.dispatch("beru/cancelShiftNeeds", id);

   toast.success("Успешно", {
      position: POSITION.BOTTOM_RIGHT,
    });
    emit("toggleInfoModal");
    emit("canceled");
  } catch (e) {
    const err = e as AxiosError<ErrorResponseData>;
    toast.error(err.status === 500 ? "Ошибка загрузки данных" : err.response?.data?.message,
    { position: POSITION.BOTTOM_RIGHT}
    );
  } finally {
    isDetailLoading.value = false;
    cancelInProgress.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_vita_icon = _resolveComponent("vita-icon")!

  return (_openBlock(), _createBlock(VitaInfoModal, {
    open: __props.open,
    onToggleInfoModal: _cache[3] || (_cache[3] = ($event: any) => (emit('toggleInfoModal'))),
    "modal-icon": false,
    "modal-size": "modal-secondary modal-beru-detail",
    title: 'Потребность № ' + __props.card?.serialNumber,
    onOpen: onBeruModalOpen
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(PerfectScrollbar), {
        class: "beru-detail-scroll rail-gap-vertical rail-thin rail-lightgray",
        options: scrollOptions,
        ref_key: "timelineScroll",
        ref: timelineScroll
      }, {
        default: _withCtx(() => [
          (isDetailLoading.value)
            ? (_openBlock(), _createBlock(VitaLoaderSpinner, {
                key: 0,
                "data-qa": "beru-detail-loader"
              }))
            : (detailError.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(VitaEmptyPlaceholder, {
                    "qa-name": "beru-detail-error",
                    icon: "isOffline",
                    message: detailError.value,
                    description: "При загрузке данных произошла ошибка. Попробуйте обновить страницу позже.",
                    "icon-width": "100",
                    "icon-height": "100",
                    "on-refresh-click": onBeruModalOpen
                  }, null, 8, ["message"])
                ]))
              : (beruDetail.value && Object.keys(beruDetail.value).length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("ul", null, [
                        (beruDetail.value.shiftCost)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_4, " +" + _toDisplayString(beruDetail.value.shiftCost), 1))
                          : _createCommentVNode("", true),
                        (beruDetail.value.shiftCostRD)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_5, " ~РД " + _toDisplayString(beruDetail.value.shiftCostRD), 1))
                          : _createCommentVNode("", true)
                      ]),
                      (beruDetail.value.armZortCanceledAt)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Отменена "))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", null, [
                        (beruDetail.value.pharm?.name)
                          ? (_openBlock(), _createElementBlock("h2", _hoisted_8, "Аптека №" + _toDisplayString(beruDetail.value.pharm?.name), 1))
                          : _createCommentVNode("", true),
                        (beruDetail.value.dateFrom && beruDetail.value.dateTo)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(formatTime(beruDetail.value.dateFrom)) + " - " + _toDisplayString(formatTime(beruDetail.value.dateTo)), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        (shiftDuration.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _createVNode(_component_vita_icon, { name: "clock-circle" }),
                              _createElementVNode("span", null, _toDisplayString(`${shiftDuration.value.toLocaleString("ru-RU")}ч`), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (dinnerDuration.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                              _createVNode(_component_vita_icon, { name: "dinner-circle" }),
                              _createElementVNode("span", null, _toDisplayString(`${dinnerDuration.value.toLocaleString("ru-RU")}ч`), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("dl", _hoisted_13, [
                      (beruDetail.value.dateFrom)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _cache[4] || (_cache[4] = _createElementVNode("dt", { "data-qa": "beru-detail-label-date" }, "Дата", -1)),
                            _createElementVNode("dd", _hoisted_14, _toDisplayString(formatDate(beruDetail.value.dateFrom)), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (beruDetail.value.pharm?.webAddress)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("dt", _hoisted_15, "Адрес аптеки №" + _toDisplayString(beruDetail.value.pharm?.name), 1),
                            _createElementVNode("dd", _hoisted_16, [
                              (beruDetail.value.pharm?.cityName)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(beruDetail.value.pharm?.cityName) + ", ", 1))
                                : _createCommentVNode("", true),
                              (beruDetail.value.pharm?.webAddress)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(beruDetail.value.pharm?.webAddress), 1))
                                : _createCommentVNode("", true)
                            ])
                          ], 64))
                        : _createCommentVNode("", true),
                      (beruDetail.value.reasonForChange)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _cache[5] || (_cache[5] = _createElementVNode("dt", { "data-qa": "beru-detail-label-reason" }, "Причина", -1)),
                            _createElementVNode("dd", _hoisted_19, _toDisplayString(beruDetail.value.reasonForChange), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (beruDetail.value.typeReasonForChange)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                            _cache[6] || (_cache[6] = _createElementVNode("dt", { "data-qa": "beru-detail-label-reason-type" }, "Вид причины", -1)),
                            _createElementVNode("dd", _hoisted_20, _toDisplayString(beruDetail.value.typeReasonForChange), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (beruDetail.value.anchor && beruDetail.value.anchor?.name)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                            _cache[7] || (_cache[7] = _createElementVNode("dt", {
                              class: "top-divider",
                              "data-qa": "beru-detail-label-anchor"
                            }, "Якорная аптека", -1)),
                            _createElementVNode("dd", _hoisted_21, [
                              (beruDetail.value.anchor?.name)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Аптека №" + _toDisplayString(beruDetail.value.anchor?.name) + ",", 1))
                                : _createCommentVNode("", true),
                              (beruDetail.value.anchor?.webAddress)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(beruDetail.value.anchor?.webAddress), 1))
                                : _createCommentVNode("", true)
                            ])
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    (beruDetail.value.exchangeWeb?.length)
                      ? (_openBlock(), _createBlock(VitaBeruTimeline, {
                          key: 0,
                          "exchange-web": beruDetail.value.exchangeWeb,
                          onToggle: onTimelineToggle
                        }, null, 8, ["exchange-web"]))
                      : _createCommentVNode("", true),
                    (isShiftFree.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          (showCancellationConfirm.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                _cache[10] || (_cache[10] = _createElementVNode("div", { "data-qa": "beru-detail-confirm-cancel-text" }, "Вы уверены, что хотите отменить потребность?", -1)),
                                _createElementVNode("div", null, [
                                  _createVNode(VitaButton, {
                                    class: "rounded no-shadow",
                                    color: "red",
                                    width: "inline",
                                    "btn-loading": cancelInProgress.value,
                                    onClick: _cache[0] || (_cache[0] = ($event: any) => (cancelBeruShift(beruDetail.value.id))),
                                    "data-qa": "beru-detail-button-cancel-confirm"
                                  }, {
                                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                      _createTextVNode("Да", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["btn-loading"]),
                                  _createVNode(VitaButton, {
                                    class: "rounded no-shadow",
                                    color: "blue",
                                    width: "inline",
                                    onClick: _cache[1] || (_cache[1] = ($event: any) => (showCancellationConfirm.value = false)),
                                    "data-qa": "beru-detail-button-cancel-reject"
                                  }, {
                                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                      _createTextVNode("Нет", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (!showCancellationConfirm.value)
                            ? (_openBlock(), _createBlock(VitaButton, {
                                key: 1,
                                class: "rounded no-shadow",
                                width: "inline",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (showCancellationConfirm.value = true)),
                                "data-qa": "beru-detail-button-cancel-open"
                              }, {
                                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                  _createTextVNode(" Отменить потребность ", -1)
                                ]))]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }, 8, ["open", "title"]))
}
}

})